import React from 'react';
import { styled } from '@mui/material/styles';
import TableCell, { TableCellProps } from '@mui/material/TableCell';

const CustomTableCell = styled(TableCell)({
	padding: '15px 10px',
	cursor: 'pointer',
});

export const TableCellBody: React.FC<TableCellProps> = (props) => {
	const { children, ...otherProps } = props;
	return (
		<CustomTableCell {...otherProps}>
			{children}
		</CustomTableCell>
	);
};